import { Button } from '@global-engineering-shared/gweb-material-ui';
import React from 'react';

import useStyles from 'components/VisibilityToggleButton/VisibilityToggleButton.styles';

type VisibilityToggleButtonProps = {
  text: string;
  visibilityValue: boolean;
  setWithVisibilityValue: React.Dispatch<React.SetStateAction<boolean>>;
};

const VisibilityToggleButton = ({
  text,
  visibilityValue,
  setWithVisibilityValue,
}: VisibilityToggleButtonProps) => {
  const classes = useStyles();

  return (
    <Button
      className={classes.root}
      variant="text"
      onClick={() => setWithVisibilityValue(visibilityValue)}
    >
      {text}
    </Button>
  );
};

export default VisibilityToggleButton;
